import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";

export function EmptyState({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        // TUT-162 fatia 5 — o que o componente diz sobre o `<p>` é DEFAULT.
        //
        // `[&_p]:text-[var(--muted)]` é a mesma forma que já mordeu uma vez: o
        // `PageHeading` fixava exatamente isso, e a TUT-160 fase c pagou o
        // conserto tirando o elemento do alcance da regra em vez de brigar por
        // especificidade. Aqui são 30 arquivos e 55 usos, sem colisão medida
        // hoje — ou seja, armadilha armada e ainda não pisada.
        //
        // `:where(&)` zera a especificidade do lado do pai (`:where(.classe) p`,
        // 0,0,1), então qualquer classe posta no próprio `<p>` vence. Nenhum
        // chamador atual muda de aparência; o que muda é que o próximo pode
        // discordar sem `!important`.
        "grid min-h-[160px] place-items-center p-6 text-center",
        "[:where(&)_p]:mx-0 [:where(&)_p]:mb-0 [:where(&)_p]:mt-[0.35rem] [:where(&)_p]:max-w-[360px] [:where(&)_p]:text-[var(--muted)]",
        className,
      )}
      {...props}
    />
  );
}
